module.exports = __webpack_public_path__ + "static/app-mockup-3d00c2686348b7dca649cf68c0195c0e.png";